module.exports = __webpack_public_path__ + "img/3-01-20-safety-first.de828118.svg";